import { ProposalFlow } from './ProposalFlow'
import { ContractFlow } from './ContractFlow'
import { useIndicationFlow } from '~/contexts'

export const IndicationsCreateV2: React.FC = () => {
  const { selectedContract } = useIndicationFlow()
  return selectedContract ? <ContractFlow /> : <ProposalFlow />
}
